import { ClassConstructor, plainToInstance } from "class-transformer";

import BaseButtonBuilder
  from "../../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons";
import {
  ButtonBuildersGroups
} from "../../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types";
import { FileType } from "../../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/Media/types";
import { PostActionTypeEnum } from "../../../../../../shared/modules/posting/types";
import { VueComponent } from "../../../../../../shared/types/VueComponent";
import { PostActionBuilder } from "../PostActionBuilder";
import { PostActionStructure } from "../PostActionStructure";
import EditPostActionModel from "./EditPostActionModel";

export default class EditPostActionBuilder extends PostActionBuilder {
    type: PostActionTypeEnum = PostActionTypeEnum.EditPostAction;

    icon= 'edit_note'
    view: VueComponent | undefined = () => import('./EditPostActionView.vue')
    valueView: VueComponent | undefined = () => import('../components/PostActionMessage/PostActionMessageValuePreview.vue')

    declare actionProps: (() => {
      buttons?: Array<BaseButtonBuilder> | Array<ButtonBuildersGroups>
      mediaUploadTarget?: string
      editorSettingsStructure?: Record<string, any>
      editorButtonsHelpView?: VueComponent | null
      blacklistMediaButtonTypes?: Array<FileType>
    }) | undefined

    createAction(constructor: ClassConstructor<PostActionStructure>): PostActionStructure {
      return plainToInstance(constructor, { action: new EditPostActionModel() } )
    }
}
